/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {L10nTranslationService} from 'angular-l10n';
import {ComboboxItem} from '../layouts/components/cp-models';

@Pipe({
    name: 'enumConvert',
    standalone: false
})
export class YascPipeKeyValue implements PipeTransform {

    transform(data: any, translation?: L10nTranslationService): ComboboxItem[] {
        let enumKeys: ComboboxItem[] = [];
        for (let enumMember in data) {
            const isValueProperty = Number(enumMember) >= 0
            if (isValueProperty) {
                if (translation !== undefined) {
                    let translationKey = `${data[enumMember][0].toLowerCase()}${data[enumMember].slice(1)}`;
                    enumKeys.push(new ComboboxItem(translation.translate(translationKey), Number(enumMember)));
                } else {
                    enumKeys.push(new ComboboxItem(data[enumMember], Number(enumMember)));
                }
            }
        }
        return enumKeys;
    }
}